import { memo } from "react";
import { HEROSECTION_MEDIA_SOURCES } from "../../../../utils/config/mediaSources/heroSection";
import { renderSources } from "../../../../utils/index.ts";

const RightImage = memo(function RightImage() {

	return (
		<picture
			tabIndex={-1}
			className={`
				w-[50%] sm:w-[45%] h-fit aspect-square 
				drop-shadow-[-30px_30px_30px_rgba(0,0,0,0.3)] 2xl:drop-shadow-[-3vw_3vw_3vw_rgba(0,0,0,0.3)]
				will-change-transform
				hover:rotate-12 focus:rotate-12 hover:scale-110 active:scale-90
				transition-transform duration-1500 ease-in-out`}
		>
			{renderSources(HEROSECTION_MEDIA_SOURCES.heroSection.rightImageSet.srcSet)}
			<img
				src={HEROSECTION_MEDIA_SOURCES.heroSection.rightImageSet.img.defaultSrc}
				alt={HEROSECTION_MEDIA_SOURCES.heroSection.rightImageSet.img.alt}
				role="presentation"
				loading="eager"
				fetchPriority="high"
				width={HEROSECTION_MEDIA_SOURCES.heroSection.rightImageSet.img.width}
				height={HEROSECTION_MEDIA_SOURCES.heroSection.rightImageSet.img.height}
				className="w-full aspect-square"
				style={{
					containIntrinsicSize: "400px 400px",
					/* transform: "translateZ(0)", */
					backfaceVisibility: "hidden",
					display: "block",
				}}
				decoding="sync"
			/>
		</picture>
	);
});

export default RightImage;